import React from 'react';
import { Box, Typography } from '@mui/material';
import CustomTitleWithBlueBackground from '../../common/CustomTitleWithBlueBackground';
import InstructionsNumberedList from './InstructionsNumberedList';
import { useThemeContext } from '../../../contexts/BaseThemeContextProvider';

const instructionsOne = [
  'Choose which finger you want to prick. The best is the middle or ring finger of your non-dominant hand.',
  'Clean the finger tip with the alcohol wipe.',
  'Find the correct place to take the sample. This is to one side of the centerline of the fingertip on the fleshy pad.',
  'Place the tip of the lancet on the finger tip and push in firmly. It will click, prick your finger, and retract the needle.',
  'Wait for a few seconds for the first drop of blood to form. If needed, you can massage from the palm of your hand up towards the tip to improve blood flow.',
];

const instructionsTwo = [
  'Wipe away the first drop of blood using the sterile gauze.',
  'Now hold your hand out flat. Take the sampler and touch the first sampler tip to the blood drop from above as shown. Wait until the tip is completely filled as shown and then wait for at least 2 more seconds before slowly removing the device.',
  'Repeat step 7 for the other tips.',
  'Place the sampler down carefully while you bandage your finger.',
];

const TakeYourSampleInstructions = () => {
  const { theme } = useThemeContext();
  return (
    <Box sx={{ p: 0, mt: 2 }}>
      <CustomTitleWithBlueBackground text="Taking your sample" gutterBottom={false} parentSxProps={{ mb: 2 }} />
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' },
          gap: { md: 3 },
        }}
      >
        <Box>
          <InstructionsNumberedList lists={instructionsOne} />
        </Box>
        <Box>
          <InstructionsNumberedList lists={instructionsTwo} startingIndex={5} />
          <Typography
            sx={{
              color: theme.custom.pages.howTo.takeSampleCollection.tabs.collectingSampleWarning.color,
              mt: 2,
              fontSize: '0.9em',
            }}
          >
            *If you have trouble collecting enough blood, or if the blood clots too fast, you can repeat the steps using
            a new lancet on one of your other fingers
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default TakeYourSampleInstructions;
